var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",class:{ invert: _vm.invert },attrs:{"to":{ name: _vm.to }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }